import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';

import { Grid } from '@material-ui/core';

import StepProgress from '../../../../components/StepProgress';
import Accordion from '../../../../components/Accordion';
import steps from '../../../../utils/steps.json';
import cartilha from '../../../../assets/docs/Cartilha.pdf';
import SearchContainer from '../../../../components/SearchContainer';
import Modal from '../../../../components/Modal';
import Button from '../../../../components/Button';
import DataTableMui from '../../../../components/DataTableMui';

import { buscaBeneficiarioAposentadosdemitidos, dadosBeneficiarioAposentadosdemitidos } from '../../../../services';

import { addMaskCpf } from '../../../../utils';
import { useAposentadosDemitidos } from '../../../../contexts/AposentadosDemitidos/context';
import { useGlobal } from '../../../../contexts/Global/context';

import { ContainerDataTable, PageContainer } from '../../../../styles/styles';

import * as S from './styles';
import PageLoader from '../../../../components/PageLoader';

function Selecionar() {
    const { setDataContrato, setDataBeneficiario, clearAposentadosDemitidos } = useAposentadosDemitidos();

    const { dataActiveContract, contrastTheme } = useGlobal();

    const history = useHistory();

    const emptyMessage = 'Não encontramos esse beneficiário. Você pode fazer uma nova pesquisa.';

    const [loading, setLoading] = useState(false);
    const [pageLoading, setPageLoading] = useState(false);
    const [alreadySearched, setAlreadySearched] = useState(false);
    const [dataTable, setDataTable] = useState([]);
    const [beneficiarios, setBeneficiarios] = useState([]);
    const [showErrorModal, setShowErrorModal] = useState(false);

    useEffect(() => {
        clearAposentadosDemitidos();
    }, []);

    async function handleSearch(value) {
        setAlreadySearched(false);

        if (value) {
            setLoading(true);

            const response = await buscaBeneficiarioAposentadosdemitidos(value.trim(), dataActiveContract.numero);

            const treatedResponse = response
                ? response.map((element, index) => ({
                      index,
                      nomeCompleto: element.nomeCompleto,
                      carteirinha: element.numCarteirinha,
                      cpf: addMaskCpf(element.cpf),
                      tipo: element.tipo,
                  }))
                : [];

            setBeneficiarios(response);

            setDataTable(treatedResponse);

            setAlreadySearched(true);
        }

        setLoading(false);
    }

    const columnsHead = [
        {
            key: 'numCarteirinha',
            selector: (row) => row.carteirinha || '-',
            name: 'Nº da carteirinha',
            sortable: true,
            direction: 'left',
            customStyles: () => ({ padding: '0 16px 0 24px', width: '200px' }),
        },
        {
            key: 'nomeCompleto',
            selector: (row) => row.nomeCompleto || '-',
            name: 'Nome completo',
            sortable: true,
            direction: 'left',
            customStyles: () => ({ width: 'calc(100% - 600px)', height: '60px' }),
        },
        {
            key: 'cpf',
            selector: (row) => row.cpf || '-',
            name: 'CPF',
            sortable: true,
            direction: 'left',
            customStyles: () => ({ width: '200px' }),
        },
        {
            key: 'tipoOperacao',
            selector: (row) => row.tipo,
            name: 'Tipo',
            sortable: true,
            direction: 'center',
            customStyles: () => ({ width: '200px' }),
        },
    ];

    async function handleClickRow(row) {
        const rawData = beneficiarios[row.index];

        setPageLoading(true);

        const dadosBeneficiario = await dadosBeneficiarioAposentadosdemitidos(
            rawData.numCarteirinha,
            dataActiveContract.numero
        );

        if (dadosBeneficiario?.contrato) {
            setDataBeneficiario(dadosBeneficiario);

            const contrato = dataActiveContract;

            contrato.numero = contrato.numero.toString();

            setDataContrato(contrato);

            history.push('/movimentacao_cadastral/preencher_dados_aposentados_demitidos');

            return;
        }

        setPageLoading(true);

        setShowErrorModal(true);
    }

    const rowMutation = {
        click: (row) => {
            handleClickRow(row);
        },
        hasClick: () => true,
    };

    return (
        <>
            <PageContainer>
                <StepProgress steps={steps.aposentadosDemitidos} activeStep={1} />

                <Accordion title="Pesquisar beneficiário" hasCollapse={false}>
                    <S.SearchGroup>
                        <SearchContainer
                            field={{
                                id: 'searchField',
                                label: 'Digite o nº da carteirinha, nome ou CPF',
                                required: true,
                            }}
                            disabled={loading}
                            onSearch={handleSearch}
                        />
                        <S.LinkCartilha
                            contrastTheme={contrastTheme}
                            href={cartilha}
                            download="Cartilha de Orientações"
                        >
                            <span className="material-icons-outlined md-10">south</span>
                            Cartilha de orientações
                        </S.LinkCartilha>
                    </S.SearchGroup>
                </Accordion>
            </PageContainer>

            <ContainerDataTable>
                <DataTableMui
                    clickableRow
                    rowMutation={rowMutation}
                    data={dataTable}
                    emptyMessage={emptyMessage}
                    loading={loading}
                    columns={columnsHead}
                    alreadySearched={alreadySearched}
                    firstOrderBy="numCarteirinha"
                />
            </ContainerDataTable>

            <Modal
                title="Atenção"
                visible={showErrorModal}
                closable={false}
                onCancel={() => setShowErrorModal(false)}
                footer={null}
            >
                Ocorreu um erro inesperado, por favor tente novamente.
                <Grid container direction="row" justifyContent="flex-start" alignItems="center">
                    <Button style={{ marginTop: '20px' }} onClick={() => setShowErrorModal(false)}>
                        Ok
                    </Button>
                </Grid>
            </Modal>

            <PageLoader loading={pageLoading} />
        </>
    );
}

export default Selecionar;
